module.exports = __webpack_public_path__ + "media/svg/img-android-e31001fd.jpg";